<jml-lib-entity-tile [tableData]="tableData"></jml-lib-entity-tile>
<jml-lib-dto-actions [dtoType]="dtoType"></jml-lib-dto-actions>
<jml-lib-dynamic-table
  [tableData]="tableData"
  [token]="token$ | async"
  [preselectionId]="id$ | async"
  [activateTableState]="true"
></jml-lib-dynamic-table>
